import React from 'react'
import WalidacjaFailsStyle from '../styles/WalidacjaFailsStyle'
import WalidacjaError from './WalidacjaError'

export default function WalidacjaFails({ errors }) {
  return (
    <WalidacjaFailsStyle>
      <p className="high-headline-5">ZNALEZIONE PROBLEMY</p>
      <ul>
        {errors.map((e, i) => (
          <li key={i}>
            <WalidacjaError
              errors={errors}
              error={e}
              index={errors.indexOf(e) + 1}
              count={errors.length}
            />
          </li>
        ))}
      </ul>
    </WalidacjaFailsStyle>
  )
}
